// extracted by mini-css-extract-plugin
module.exports =  {"tags-input":"bmQvV5j","tagsInput":"bmQvV5j"};